import React from 'react';
import { ReactComponent as FigmaOrgHomeIcon } from '../icons/figma/organizer-header/home-bulk-icon.svg';
import { ReactComponent as FigmaOrgSearchIcon } from '../icons/figma/organizer-header/search-normal-bulk-icon.svg';
import { ReactComponent as FigmaOrgStickynoteIcon } from '../icons/figma/organizer-header/stickynote-bulk-icon.svg';
import { ReactComponent as FigmaOrgNotificationIcon } from '../icons/figma/organizer-header/notification-bulk-icon.svg';
import { ReactComponent as FigmaOrgArrowDownIcon } from '../icons/figma/organizer-header/arrow-down-linear-icon.svg';

export const IconHome = ({ className = '' }) => (
  <FigmaOrgHomeIcon className={className} aria-hidden="true" />
);

export const IconSearch = ({ className = '' }) => (
  <FigmaOrgSearchIcon className={className} aria-hidden="true" />
);

export const IconBookings = ({ className = '' }) => (
  <FigmaOrgStickynoteIcon className={className} aria-hidden="true" />
);

export const IconNotification = ({ className = '' }) => (
  <FigmaOrgNotificationIcon className={className} aria-hidden="true" />
);

export const IconArrowDown = ({ className = '' }) => (
  <FigmaOrgArrowDownIcon className={className} aria-hidden="true" />
);

export const IconArrowLeft = ({ className = '' }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconCheck = ({ className = '' }) => (
  <svg className={className} width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconUsers = ({ className = '' }) => (
  <img src="/manual-booking/icons/profile-users.svg" alt="" className={className} width="16" height="16" aria-hidden="true" />
);

export const IconCalendar = ({ className = '' }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M8 2V5M16 2V5M7 11H17M7 15H13M7 3.5H17C18.933 3.5 20.5 5.067 20.5 7V17C20.5 18.933 18.933 20.5 17 20.5H7C5.067 20.5 3.5 18.933 3.5 17V7C3.5 5.067 5.067 3.5 7 3.5Z" />
  </svg>
);

export const IconClock = ({ className = '' }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 8V13L15 15M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
  </svg>
);

export const IconTimer = ({ className = '' }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 8V13L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.3054 3 16.4077 3.83481 18 5.29102" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
  </svg>
);

export const IconProfile = ({ className = '' }) => (
  <img src="/manual-booking/icons/profile.svg" alt="" className={className} width="16" height="16" aria-hidden="true" />
);

export const IconMessage = ({ className = '' }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8 10H16M8 14H13M7 20L8.5 16.5H17C18.933 16.5 20.5 14.933 20.5 13V7C20.5 5.067 18.933 3.5 17 3.5H7C5.067 3.5 3.5 5.067 3.5 7V13C3.5 14.933 5.067 16.5 7 16.5H7.5L7 20Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
